import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { VesselRate } from 'anchor-shared/lib/model/entity/vessel-rate';
import { MooringLocation } from 'anchor-shared/lib/model/entity/mooringLocation';

@Injectable()
export class MooringLocationDAO extends BaseDAO<MooringLocation> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.MOORING_LOCATION);
  }

  public getByVesselId(vesselId: number): Observable<MooringLocation> {
    const url = `${this.apiHelper.getServiceName()}${this.getResource()}/vessel/${vesselId}`;
    const method = 'GET';
    const headers = this.apiHelper.getDefaultHeader();
    const data = {};

    return this.apiHelper.apiCall<MooringLocation>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  public loadForVessel(vesselId: number): Observable<MooringLocation> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/vessel/${vesselId}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<MooringLocation>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public updateMooringLocation(
    mooringLocation: MooringLocation,
    vesselId: number,
  ): Observable<MooringLocation> {
    const url =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      mooringLocation.id;
    const method = 'PUT';
    const headers = this.apiHelper.getDefaultHeader();
    const data = {
      vesselId: vesselId,
      address: mooringLocation.address,
      lat: mooringLocation.lat,
      long: mooringLocation.long,
      parkingAddress: mooringLocation.parkingAddress,
      parkingLat: mooringLocation.parkingLat,
      parkingLong: mooringLocation.parkingLong,
      mooringAddressComponents: mooringLocation.mooringAddressComponents,
      parkingAddressComponents: mooringLocation.parkingAddressComponents,
    };

    return this.apiHelper.apiCall<MooringLocation>(
      url,
      method,
      null,
      data,
      headers,
    );
  }
}
